import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.isVisible = this.#isVisible()

    if (!this.isVisible) {
      this.observer = new IntersectionObserver(
        this.#onIntersection.bind(this),
        {
          rootMargin: "100px",
          threshold: 0.01,
        }
      )
      this.observer.observe(this.element)
    }

    document.addEventListener("form:changed", this.#update.bind(this))
  }

  disconnect() {
    document.removeEventListener("form:changed", this.#update.bind(this))
    if (this.observer) this.observer.disconnect()
  }

  #update({ detail: { params } }) {
    const url = `${this.element.src.split("?")[0]}?${new URLSearchParams(
      params
    )}`

    this.isVisible
      ? (this.element.src = url)
      : (this.element.dataset.pendingSrc = url)
  }

  #onIntersection(entries) {
    for (const entry of entries) {
      if (entry.target !== this.element) continue

      this.isVisible = entry.isIntersecting

      if (entry.isIntersecting && this.element.dataset.pendingSrc) {
        this.element.src = this.element.dataset.pendingSrc
        delete this.element.dataset.pendingSrc
      }
    }
  }

  #isVisible() {
    const rect = this.element.getBoundingClientRect()
    return rect.top < window.innerHeight && rect.bottom > 0
  }
}
